export enum SituacaoPedido {
    EmCriacao = 0, // Draft
    Criado = 1, // Aguardando Processamento
    ProcessamentoIniciado = 2,
    ParcialmenteProcessado = 3,
    ProcessadoComSucesso = 4,
    NaoProcessado = 5,
    Cancelado = 6, // Usuário Gestor
}
